import React from "react";
import { styled } from '@mui/material/styles';
import {IconButton} from "@mui/material";
const PREFIX = 'ActionComponent';

const classes = {
  close: `${PREFIX}-close`
};

const StyledIconButton = styled(IconButton)(() => ({
  [`&.${classes.close}`]: {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 999,
  }
}));

export default function ActionComponent(props) {

  return (
    <StyledIconButton
      disabled={props.disabled || false}
      className={classes.close}
      color="primary"
      onClick={props.action}
      size="large">{props.icon}</StyledIconButton>
  );
}
